import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { editDetail } from "../../api/editProfile";
import { storageHelper } from '../../lib';
import { useAppContext } from '../../lib/context';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

export default function Profile() {
  const classes = useStyles();
  const [{user}] = useAppContext();
  const [firstName, setFirstName] = useState(null);
  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [userClass, setUserClass] = useState('');

  const handleChange = (event) => {
    setUserClass(event.target.value);
  };

  const registerUser = async (event) => {
    event.preventDefault();
    const response = await editDetail(
      {
        phoneNumber: storageHelper.get("phone"),
        password: password,
        userId: user && user.uid,
        userClass: userClass,
        email: email,
        firstName: firstName,
      }
    );

    if (response) {
      storageHelper.remove("route");
      return {
        message: 'User Register successfully.',
        status: 'ok',
        data: response,
      };
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <br />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <AccountCircleIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Edit Profile
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="name"
                label="Full Name"
                name="name"
                autoComplete="name"
                onChange={(event) => setFirstName(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                onChange={(event) => setEmail(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={(event) => setPassword(event.target.value)}
              />
            </Grid>
            <FormControl className={classes.formControl}>
              <Grid item xs={12}>
                <Select
                  value={userClass}
                  onChange={handleChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="">
                    <em>Select Class</em>
                  </MenuItem>
                  <MenuItem value={"9"}>Nine</MenuItem>
                  <MenuItem value={"10"}>Ten</MenuItem>
                  <MenuItem value={"12"}>Twelve</MenuItem>
                </Select>
                {/* <FormHelperText>Select Class</FormHelperText> */}
              </Grid>
            </FormControl>
          </Grid>
          <Button
            id="sign-in-button"
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={(event) => registerUser(event)}
          >
            Submit
          </Button>
        </form>
      </div>
    </Container>
  );
}